
<app-form-array-input     [parentFormGroup]="parentFormGroup"
                          [parentFormControlName]="jsonControlName"
                          [canReorder]="true"
                          [buildNewItemForm]="newRow" *ngIf="parentFormGroup">
  <ng-template template-content let-itemFormGroup='itemFormGroup'>
    <ion-grid>
      <ion-row>
        <app-form-field label="Libellé" [required]="true">
          <app-input-text [parentFormGroup]="itemFormGroup" parentFormControlName="label"></app-input-text>
        </app-form-field>
        <app-form-field label="Valeur par défaut">
          <app-input-text [parentFormGroup]="itemFormGroup" parentFormControlName="defaultValue"></app-input-text>
        </app-form-field>
      </ion-row>
      <ion-row>
        <app-form-field label="Mesure" [required]="true" size="12" sizeLg="6" sizeXl="6">
          <app-form-definition-field-search-by-label
                  contextValue="FORM_CONTEXT_EXAM"
                  attributeValue="name"
                  [parentFormGroup]="itemFormGroup"
                  parentFormControlName="formDefinitionFieldName"></app-form-definition-field-search-by-label>
        </app-form-field>
      </ion-row>
    </ion-grid>
  </ng-template>
</app-form-array-input>
